import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './CourseFormatCard.styles'

interface InfoCardProps {
  title: string
  lines: string[]
}

const CourseFormatCard = ({ title, lines }: InfoCardProps) => {
  const classes = useStyles()
  return (
    <Box className={classes.card}>
      <Typography className={classes.title}>{title}</Typography>
      {lines.map((line, index) => (
        <Typography key={index} className={classes.line}>
          {line}
        </Typography>
      ))}
    </Box>
  )
}

export default CourseFormatCard
